<template>
  <b-form-group :invalid-feedback="errorTxt" :state="state">
    <b-input-group :prepend="label?label:$t('gateway')">
      <multiselect v-model="selected" class="gateway-select" :options="options" track-by="value" label="text"
                   :placeholder="$t('selectGateway')" :disabled="disabled" :class="{'is-invalid': state === false}"
                   :select-label="''" :deselect-label="''" :selected-label="''">
        <template v-slot:noResult>
          {{ $t('notFound') }}
        </template>
      </multiselect>
    </b-input-group>
  </b-form-group>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  components: {Multiselect},
  props: {
    model: Object,
    attribute: {type: String, default: 'gateway'},
    service: {type: String, default: '/gateway'},
    label: String,
    errors: Array,
    disabled: Boolean
  },
  data() {
    return {
      inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
      state: null,
      errorTxt: '',
      options: [],
    }
  },
  computed: {
    selected: {
      get() {
        return this.options.find(o => o.value === this.inputVal) || null;
      },
      set(val) {
        this.inputVal = val ? val.value : null;
      }
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        this.inputVal = val[this.attribute];
      }, deep: true
    },
    inputVal(val) {
      this.state = null;
      this.errorTxt = '';
      this.model[this.attribute] = val;
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  methods: {
    load() {
      this.options = [];
      this.$bgService.get(this.service, {
        params: {
          page: 1,
          pageSize: 1000,
          status: 0,
          host: this.host
        }
      }).then(response => {
        let found = false;
        response.data.docs.forEach(item => {
          this.options.push({value: item._id, text: `${item.name}`});
          if (item._id === this.model[this.attribute]) {
            found = true;
          }
        });
        if (found) {
          this.inputVal = this.model[this.attribute] ? this.model[this.attribute] : null;
        } else {
          this.inputVal = null;
        }
      });
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        selectGateway: 'Select gateway',
        notFound: 'No gateway found',
      },
      vi: {
        selectGateway: 'Chọn gateway',
        notFound: 'Không tìm thấy gateway',
      }
    }
  }
}
</script>

<style scoped>
.gateway-select {
  flex: 1 1 auto;
  width: 1%;
  min-width: 200px;
  min-height: 37px;
}
.gateway-select::v-deep .multiselect__tags {
  min-height: 37px;
  padding: 6px 30px 0 8px;
  font-size: 1rem;
  border-radius: 0 .25rem .25rem 0;
}
.gateway-select::v-deep .multiselect__select {
  height: 35px;
}
.gateway-select::v-deep .multiselect__placeholder,
.gateway-select::v-deep .multiselect__single {
  margin-bottom: 0;
  padding-top: 0;
}
</style>
